import React from 'react';

/**
 * rowActivation — the ONE keyboard-activation contract for clickable rows/cards (A4; corpus
 * D-C12/D-L7/D-D11 + the Ticket row). Every CRM card declared role="button" + tabIndex={0} and then
 * did NOTHING on Enter/Space — worse than an unlabelled div, because assistive tech promises an
 * action that is not there. TaskCard was the only one with a working handler; this is that handler
 * extracted so the promise and the behaviour cannot drift apart per-component again.
 *
 * Spread the result onto the interactive element (it supplies role/tabIndex/onKeyDown; the caller
 * keeps its own onClick):  <div {...rowActivation(() => onOpen(x))} onClick={() => onOpen(x)}>
 */
export function rowActivation(activate: () => void): {
  role: 'button'; tabIndex: number; onKeyDown: (e: React.KeyboardEvent) => void;
} {
  return {
    role: 'button',
    tabIndex: 0,
    onKeyDown: (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
    },
  };
}
